import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  apprBnfTitle: 'Thank you for your approval!',
  apprBnfSubtitle:
    'You have authorized your promoter {{promoter}} to transfer funds to this beneficiary',
  rjctBnfTitle: 'You have rejected this beneficiary',
  rjctBnfSubtitle:
    'Your promoter will be able to see the rejected beneficiary in your global EFEX account',
  xprBnfTitle: 'We are sorry!',
  xprBnfSubtitle:
    'The approval time limit has expired. Request your promoter to resend the request again.',
  appBnfCompany: 'Company',
  appBnfLegalName: 'Legal name',
  appBnfEmail: 'Email',
  appBnfCountry: 'Country',
  appBnfAddress: 'Address',
  appBnfPhone: 'Phone',
  appBnfTransactionType: 'Transaction type',
  appBnfBankName: 'Bank name',
  appBnfAccountNumber: 'Account number',
  appBnfRoutingNumber: 'Routing / ABA number',
  appBnfAccountType: 'Account type',
  appBnfRemainingTime: 'Remaining time',
  appBnfRemainingTimeDays: 'days',
  appBnfRemainingTimeHours: 'hours',
  appBnfRemainingTimeMinutes: 'minutes',
  appBnfRemainingTimeSeconds: 'seconds',
  pendingBnfTitle: 'We need approval',
  pendingBnfSubtitle:
    'We have sent an email requesting approval for this beneficiary.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const APPROVE_BENEFICIARY_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    apprBnfTitle: '¡Gracias por tu aprobación!',
    apprBnfSubtitle:
      'Has autorizado a tu promotor {{promoter}} transferencias a este beneficiario',
    rjctBnfTitle: 'Has rechazado este beneficiario',
    rjctBnfSubtitle:
      'Tu promotor podrá ver el beneficiario rechazado en tu cuenta global de EFEX',
    xprBnfTitle: '¡Lo sentimos!',
    xprBnfSubtitle:
      'El tiempo límite de aprobación a expirado. Solicita a tu promotor que reenvíe la solicitud nuevamente.',
    appBnfCompany: 'Empresa',
    appBnfLegalName: 'Nombre legal',
    appBnfEmail: 'Correo',
    appBnfCountry: 'País',
    appBnfAddress: 'Dirección',
    appBnfPhone: 'Teléfono',
    appBnfTransactionType: 'Tipo de transacción',
    appBnfBankName: 'Nombre del banco',
    appBnfAccountNumber: 'Número de cuenta',
    appBnfRoutingNumber: 'Número routing / ABA',
    appBnfAccountType: 'Tipo de cuenta',
    appBnfRemainingTime: 'Tiempo para aprobar',
    appBnfRemainingTimeDays: 'días',
    appBnfRemainingTimeHours: 'horas',
    appBnfRemainingTimeMinutes: 'minutos',
    appBnfRemainingTimeSeconds: 'segundos',
    pendingBnfTitle: 'Necesitamos aprobación',
    pendingBnfSubtitle:
      'Enviamos un correo solicitando la aprobación de este beneficiario.',
  },
};

export default APPROVE_BENEFICIARY_LABELS;
